import { render, staticRenderFns } from "./PageCategory.vue?vue&type=template&id=44d41bb6&scoped=true"
import script from "./PageCategory.vue?vue&type=script&lang=js"
export * from "./PageCategory.vue?vue&type=script&lang=js"
import style0 from "./PageCategory.vue?vue&type=style&index=0&id=44d41bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d41bb6",
  null
  
)

export default component.exports